export const isBackForward = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return window?.performance?.getEntriesByType('navigation')?.[0]?.type === 'back_forward';
  } catch (_) {
    return window?.performance?.navigation?.type === 2;
  }
};

export const initBackForward = (func: () => Promise<any> | any) => {
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) return func();
  });
};

export const initChangeWindow = (func: () => Promise<any> | any) => {
  let is_focus_out = false;
  window.addEventListener('focus', () => {
    if (!is_focus_out) return;
    is_focus_out = false;
    return func();
  });
  window.addEventListener('blur', () => {
    is_focus_out = true;
  });
};
